var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.chips),function(chip,idx){return _c(chip.component,{key:idx,tag:"component",class:{
      'ml-1': idx !== 0,
      'mr-1': idx !== _vm.chips.length - 1,
    },attrs:{"chip":chip}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }